import { toast } from 'react-toastify';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_ALLOTVEHICLE,
  GET_AVAILABLESUPPLIERS,
  GET_AVAILABLEVEHICLE,
  GET_CANCELCHARGES,
  GET_CANCELTRIP,
  GET_DISPATCHVEHICLE,
} from 'resources/actionTypes';
import {
  allotVehicle,
  availableSupplierService,
  availableVehicleService,
  cancelTripService,
  cancelationChargesService,
  dispatchVehicleService,
} from 'services/Operationservice';
import store from 'redux/store';
import {
  getReservationDetails,
  getReservationList,
} from 'redux/actions/reservationAction';
import { onLoaderTrigger } from "redux/actions/commonAction";

function* putAllotVehicle(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const allotedDetails = yield call(allotVehicle, payload?.trip);
  if (allotedDetails.success) {
    yield put({
      type: GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_SUCCESS,
      allotedDetails: allotedDetails,
    });
    toast.success(allotedDetails?.message || 'Alloting Vehicle Successfully');
    store.dispatch(onLoaderTrigger(false));

    if (payload?.page === 'allot') {
      store.dispatch(getReservationList(payload?.payload));
    } else if (payload?.page === 'details') {
      store.dispatch(getReservationDetails(payload?.trip?.tripId));
    } else {
      store.dispatch(getReservationList(payload?.payload));
    }
  } else {
    yield put({
      type: GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_FAILED,
      message: allotedDetails.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(allotedDetails?.message || 'Alloting Vehicle Failed');
  }
}

export function* allotVehicleSaga() {
  yield takeEvery(GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_REQUESTED, putAllotVehicle);
}

function* getAvailablevehicle(action) {
  const payload = action.payload || {};
  const availableVehicleDetails = yield call(availableVehicleService, payload);

  if (availableVehicleDetails.success) {
    yield put({
      type: GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_SUCCESS,
      availableVehicle: availableVehicleDetails,
    });
  } else {
    yield put({
      type: GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_FAILED,
      message: availableVehicleDetails.message,
    });
      toast.error(availableVehicleDetails?.message || 'Failed to fetch Vehicle');
  }
}

export function* getAvailablevehicleSaga() {
  yield takeEvery(
    GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_REQUESTED,
    getAvailablevehicle
  );
}

function* getAvailableSuppliers(action) {
  const payload = action.payload || {};
  const availableSuppliersDetails = yield call(
    availableSupplierService,
    payload
  );

  if (availableSuppliersDetails.success) {
    yield put({
      type: GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_SUCCESS,
      availableSuppliers: availableSuppliersDetails,
    });
  } else {
    yield put({
      type: GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_FAILED,
      message: availableSuppliersDetails.message,
    });
      toast.error(availableSuppliersDetails?.message || 'Failed to fetch Suppliers');
  }
}

export function* getAvailableSupplierSaga() {
  yield takeEvery(
    GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_REQUESTED,
    getAvailableSuppliers
  );
}

function* dispatchTrip(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const dispatchTrip = yield call(dispatchVehicleService, payload?.trip);
  if (dispatchTrip.success) {
    yield put({ type: GET_DISPATCHVEHICLE.GET_DISPATCHVEHICLE_SUCCESS });
    toast.success(dispatchTrip.message);
    store.dispatch(onLoaderTrigger(false));
    if (payload?.page === 'allot') {
      store.dispatch(getReservationList(payload?.payload));
    } else if (payload?.page === 'details') {
      store.dispatch(getReservationDetails(payload?.trip?.tripId));
    } else {
      store.dispatch(getReservationList(payload?.payload));
    }
  } else {
    yield put({
      type: GET_DISPATCHVEHICLE.GET_DISPATCHVEHICLE_FAILED,
      message: dispatchTrip.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(dispatchTrip?.message || 'Dispatching Vehicle Failed');
  }
}

export function* dispatchTripSaga() {
  yield takeEvery(
    GET_DISPATCHVEHICLE.GET_DISPATCHVEHICLE_REQUESTED,
    dispatchTrip
  );
}

function* cancelTrip(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const cancelTripDetails = yield call(cancelTripService, payload?.trip);
  if (cancelTripDetails.success) {
    yield put({ type: GET_CANCELTRIP.GET_CANCELTRIP_SUCCESS });
    toast.success(cancelTripDetails.message);
    store.dispatch(onLoaderTrigger(false));
    if (payload?.page === 'allot') {
      store.dispatch(getReservationList({ status: 'alloted',page:payload?.reservationPayload?.page, pageSize:payload?.reservationPayload?.pageSize }));
    } else if (payload?.page === 'details') {
      store.dispatch(getReservationDetails(payload?.trip));
    } else {
      store.dispatch(getReservationList(payload?.reservationPayload));
    }
  } else {
    yield put({
      type: GET_CANCELTRIP.GET_CANCELTRIP_FAILED,
      message: cancelTripDetails.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(cancelTripDetails?.message || 'Cancel Trip Failed');
  }
}

export function* cancelTripSaga() {
  yield takeEvery(GET_CANCELTRIP.GET_CANCELTRIP_REQUESTED, cancelTrip);
}

function* getCancelChargesListener(action) {
  const payload = action.payload || {};
  const cancelChargesResponse = yield call(
    cancelationChargesService,
    payload?.id
  );

  if (cancelChargesResponse.success) {
    yield put({
      type: GET_CANCELCHARGES.GET_CANCELCHARGES_SUCCESS,
      cancelCharges: cancelChargesResponse,
    });
    payload?.setCancelCharges(true);
  } else {
    yield put({
      type: GET_CANCELCHARGES.GET_CANCELCHARGES_FAILED,
      message: cancelChargesResponse.message,
    });
      toast.error(cancelChargesResponse?.message || 'Failed to fetch Cancel Charges');
  }
}

export function* getCancelChargesWatcher() {
  yield takeEvery(
    GET_CANCELCHARGES.GET_CANCELCHARGES_REQUESTED,
    getCancelChargesListener
  );
}
